<div class="deposit-withdraw-sidebar-title deposit" *ngIf="userData && userData?.branch_panel_active == 1">
    <h5 class="d-inline-block m-b-0" routerLink="/deposit"><img src="https://speedcdn.io/assets/diamond-client-v8/deposit.png"> Deposit</h5>
</div>
<div class="deposit-withdraw-sidebar-title withdraw" *ngIf="userData && userData?.branch_panel_active == 1">
    <h5 class="d-inline-block m-b-0" routerLink="/withdraw"><img src="https://speedcdn.io/assets/diamond-client-v8/withdraw.png"> Withdraw</h5>
</div>
<div data-bs-toggle="collapse" data-bs-target=".casino" class="sidebar-title">
    <h5 class="d-inline-block m-b-0">Others</h5>
  </div>
  <nav class="collapse casino show">
    <ul>
      <!-- <li class="nav-item "><a href="javascript:void(0)" class="nav-link"><span class="new-launch-text">Live Casino</span></a></li> -->
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/56768" class="nav-link"><span> TP T20 </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67640" class="nav-link"><span> TP 1 DAY </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67630" class="nav-link"><span> TP TEST </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/98790" class="nav-link"><span> DT 1 DAY </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/56967" class="nav-link"><span> 32 CARDS </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/56968" class="nav-link"><span> HI LOW </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67564" class="nav-link"><span> POKER </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67620" class="nav-link"><span> QUEEN </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/92038" class="nav-link"><span> BACCARAT  </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/98791" class="nav-link"><span> AMAR AKBAR ANTHONY  </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67570" class="nav-link"><span> BOLLYWOOD  </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67610" class="nav-link"><span> TRIO  </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/87564" class="nav-link"><span> ANDAR BAHAR </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/67600" class="nav-link"><span> MUFLIS TP </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/98788" class="nav-link"><span> ROULETTE </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/92036" class="nav-link"><span> WORLI MATKA </span></a></li>
      <li class="nav-item"><a href="javascript:void(0)" (click)="_common.openLogin()" routerLink="/casino-detail/99999/98567" class="nav-link"><span> DREAM CATCHER </span></a></li>
    </ul>
  </nav>
  <div data-bs-toggle="collapse" data-bs-target=".events" class="sidebar-title m-t-5 theme2bg" aria-controls="events" aria-expanded="true" role="button">
    <h5 class="text-white d-inline-block m-b-0">All Sports</h5>
  </div>
  <div id="events" class="mtree-main collapse events show">
    <div class="ps">
      <nav>
        <ul class="mtree transit bubba"  *ngFor="let mn of menu;let i=index;trackBy:trackByIndex">
          <li class="mtree-node  item">
            
            <div class="text-dark">
              <!-- casino -->
              <a  class="side-casino-link d-block" *ngIf="events.casino.includes(mn?.id)" [routerLink]="['/casino', mn?.id]" routerLinkActive="active">
                {{mn.name}}
              </a>
              <!-- All others -->
              <a *ngIf="!events.casino.includes(mn?.id)" data-bs-toggle="collapse" href="#collapse{{i}}">  <span><i class="far fa-plus-square"></i></span>
                {{mn.name}}
              </a>
            </div>

            <!-- sport list -->
            <ul class="mtree-level-1 collapse" id="collapse{{i}}" *ngIf="!events.races.includes(mn.id)">
              <li class="mtree-node  text-dark" *ngFor="let smn of mn.child;let j=index;trackBy:trackByIndex">
                <div class="text-dark"><a data-bs-toggle="collapse" href="#collapse{{i}}{{j}}">  
                  <span><i class="far fa-plus-square"></i> <i class="far fa-minus-square" style="display: none;"></i></span>
                  {{smn.name}}</a>
                </div>
                <ul class="mtree-level-1 collapse" id="collapse{{i}}{{j}}">
                  <li class="mtree-node  text-dark">
                    <ul class="mtree-level-1">
                      <li class="mtree-node text-dark" *ngFor="let item of smn.data;let j=index;trackBy:trackByIndex">
                        <div class="text-dark">
                          <a href="javascript:void(0);" [routerLink]="['/game-detail', item?.event_id]" ><span><i class="fas fa-caret-right"></i></span>
                          {{item.name}}</a>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>

            <!-- race list -->
            <ul class="mtree-level-1 collapse" id="collapse{{i}}" *ngIf="events.races.includes(mn.id)">
              <li class="mtree-node  text-dark" *ngFor="let item of mn.data;let j=index;trackBy:trackByIndex">
                <div class="text-dark">
                  <a href="javascript:void(0);" [routerLink]="['/game-detail', item?.event_id, item?.market_id]" ><span><i class="fas fa-caret-right"></i></span>
                  {{item?.event_name}}</a>
                </div>
              </li>
            </ul>


          </li>
        </ul>
      </nav>
    </div>
  </div>